import { useContext } from "react";

import { LoaderContext } from "../contexts/LoaderProvider";

function useLoader() {
    return useContext(LoaderContext);
}

export default useLoader;
